import React from "react";
import { useAppSelector } from "../redux/store";

const LoadingLayer = () => {
  const state = useAppSelector((state) => state.loader);

  if (!state.isLoading) return null;

  return (
    <div className="loadingLayer">
      <div className="sk-chase">
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
        <div className="sk-chase-dot"></div>
      </div>
      <span>bitte warten....</span>
    </div>
  );
};

export default LoadingLayer;
